var map = {
	"./Acores.svg": 111,
	"./Alentejo.svg": 112,
	"./Algarve.svg": 113,
	"./AllWorld.svg": 114,
	"./Beiras.svg": 115,
	"./Douro.svg": 116,
	"./Lisboa.svg": 117,
	"./Madeira.svg": 118,
	"./Minho.svg": 119,
	"./Setubal.svg": 120,
	"./Tejo.svg": 121,
	"./map.svg": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;